export const FUTURE_MONEY_URL = "https://www.futuremoney.co/";
export const FUTURE_MONEY_GIFT_URL = "https://www.futuremoney.co/gift";

export const FUTURE_MONEY_TERMS_OF_SERVICE_URL = "https://www.futuremoney.co/legal-privacy";

export const FUTURE_MONEY_PRIVACY_POLICY_URL =
  "https://legal.futuremoney.co/FutureMoney+Privacy+Notice.pdf";

export const FUTURE_MONEY_INVESTMENT_MANAGEMENT_AGREEMENT_URL =
  "https://cdn.prod.website-files.com/67586034a71569132a74d55f/6a1469581e582bae14d1687a_Investment%20Management%20Agreement%20-%20January%202026.pdf";

export const FUTURE_MONEY_FORM_CRS_URL = "https://reports.adviserinfo.sec.gov/crs/crs_329835.pdf";

export const FUTURE_MONEY_FORM_ADV_PART_2A_URL =
  "https://files.adviserinfo.sec.gov/IAPD/Content/Common/crd_iapd_Brochure.aspx?BRCHR_VRSN_ID=909733";

export const FUTURE_MONEY_LEGAL_PRIVACY_URL = "https://www.futuremoney.co/legal-privacy";

export const JUNIOR_IRA_STATE_SPECIFIC_DISCLOSURES_URL =
  "https://www.futuremoney.co/articles/state-rules-for-529-to-roth-ira-rollover";

export const SWEEPSTAKES_TERMS_AND_CONDITIONS_URL = "https://www.futuremoney.co/sweepstakes";

export const VERIFIED_TERMS_OF_USE_URL = "https://www.verified.inc/legal#terms-of-use";

export const IRS_FORM_W9_URL = "https://www.irs.gov/pub/irs-pdf/fw9.pdf";

export const IRS_FATCA_URL =
  "https://www.irs.gov/businesses/corporations/fatca-information-for-individuals";

export const FINRA_URL = "https://www.finra.org/#/";

export const SIPC_URL = "https://www.sipc.org/";

export const FINRA_BROKER_CHECK_URL = "https://brokercheck.finra.org/";

export const FIVE_TWO_NINE_PLAN_DISCLOSURE_URL =
  "https://www.jhinvestments.com/resources/all-resources/fund-documents/miscellaneous/john-hancock-freedom-529-plan-disclosure-document";

export const JOHN_HANCOCK_529_PLAN_DISCLOSURE_URL =
  "https://www.jhinvestments.com/resources/all-resources/fund-documents/miscellaneous/john-hancock-freedom-529-plan-disclosure-document";

export const IRA_DISTRIBUTION_FORM_URL = "https://cdn.futuremoney.co/BD_IRA_DISTRIBUTION_FORM.pdf";

export const NEW_ACCOUNT_TYPE_URL = "https://www.futuremoney.co/legal-privacy#new-account-type";

export const REFERRAL_TERMS_AND_CONDITIONS_URL =
  "https://www.futuremoney.co/legal-privacy#referral-bonuses";

export const ALTRUIST_CUSTOMER_AGREEMENTS_AND_DISCLOSURES_URL = "https://altruist.com/legal";

export const ALTRUIST_ADVISOR_DISCLOSURES_URL_PART1 =
  "https://cdn.futuremoney.co/legal/form_adv.pdf";

export const ALTRUIST_ADVISOR_DISCLOSURES_URL_PART2A =
  "https://files.adviserinfo.sec.gov/IAPD/Content/Common/crd_iapd_Brochure.aspx?BRCHR_VRSN_ID=969457";

export const ALTRUIST_ADVISOR_DISCLOSURES_URL_PART3 =
  "https://reports.adviserinfo.sec.gov/crs/crs_329835.pdf";

export const ALTRUIST_PARTNER_BANKS_URL =
  "https://altruist.com/legal/altruist-financial-llc-participating-bank-list";

export const ALTRUIST_HIGH_YIELD_CASH_PROGRAM_DISCLOSURE_STATEMENT_URL =
  "https://altruist.com/legal/high-yield-cash-program-disclosure-statement";

export const FDIC_GOV_URL = "https://fdic.gov/";

export const ALPACA_CUSTOMER_AGREEMENT_URL =
  "https://files.alpaca.markets/disclosures/library/AcctAppMarginAndCustAgmt.pdf";

export const ALPACA_BANK_SWEEP_PROGRAM_TERMS_URL =
  "https://files.alpaca.markets/disclosures/Alpaca+FDIC+Bank+Sweep+Program+Terms+and+Conditions.pdf";

export const ALPACA_USE_AND_RISK_URL =
  "https://files.alpaca.markets/disclosures/library/UseAndRisk.pdf";

export const ALPACA_TERMS_AND_CONDITIONS_URL =
  "https://files.alpaca.markets/disclosures/library/TermsAndConditions.pdf";

export const ALPACA_PRIVACY_NOTICE_URL =
  "https://files.alpaca.markets/disclosures/library/PrivacyNotice.pdf";

export const ALPACA_PFOF_URL = "https://files.alpaca.markets/disclosures/library/PFOF.pdf";

export const ALPACA_MARGIN_DISCLOSURE_STATEMENT_URL =
  "https://files.alpaca.markets/disclosures/library/MarginDiscStmt.pdf";

export const ALPACA_EXTENDED_HOURS_RISK_URL =
  "https://files.alpaca.markets/disclosures/library/ExtHrsRisk.pdf";

export const ALPACA_BCP_SUMMARY_URL =
  "https://files.alpaca.markets/disclosures/library/BCPSummary.pdf";

export const ALPACA_FORM_CRS_URL = "https://files.alpaca.markets/disclosures/library/FormCRS.pdf";

export const TRUMP_ACCOUNTS_URL = "https://trumpaccounts.gov/";
